// extracted by mini-css-extract-plugin
export default {"container":"AssetSliceToken_container__uhjSj","mainContent":"AssetSliceToken_mainContent__qActu","details":"AssetSliceToken_details__WRORw"};